import { createRoute } from '@tanstack/react-router'
import { rootRoute } from '../__root'
import { SettingsRedirect } from '@/components/settings/legacy-redirects'

/** The old profile page → the settings dialog on Profil (board h39z). */
export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  component: SettingsRedirect,
})
